<script setup lang="ts">
import {
  PhCheck as CheckIcon,
  PhClock as ClockIcon,
  PhWarning as WarningIcon,
} from '@phosphor-icons/vue'
import type { TimelineEvent } from '../types'

defineProps<{ events: TimelineEvent[] }>()
</script>

<template>
  <ol class="timeline">
    <li v-for="event in events" :key="event.id" :class="`timeline__item timeline__item--${event.state}`">
      <span class="timeline__marker" aria-hidden="true">
        <CheckIcon v-if="event.state === 'done'" :size="15" weight="bold" />
        <WarningIcon v-else-if="event.state === 'attention'" :size="15" weight="fill" />
        <ClockIcon v-else :size="15" weight="bold" />
      </span>
      <div class="timeline__content">
        <div class="timeline__heading">
          <strong>{{ event.title }}</strong>
          <time v-if="event.occurredAt">{{ event.occurredAt }}</time>
        </div>
        <p>{{ event.description }}</p>
      </div>
    </li>
  </ol>
</template>
